// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  showErrors: true,
  //   apiUrl: 'http://client.riesko.com:8080/riesko_exp',
  // apiUrl: 'https://demo.riesko.com',
     apiUrl: 'https://dev-api.riesko.com', // Per ambiente di sviluppo
     //apiUrl: '/api', // Per ambiente di sviluppo
  basePrefixApiUrl: '/DTA', // TODO: spostare in un json
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'riesko-themecolor',
  isMultiColorActive: false,
  /*
  Color Options:
  'light.blueyale', 'light.blueolympic', 'light.bluenavy', 'light.greenmoss', 'light.greenlime', 'light.yellowgranola', 'light.greysteel', 'light.orangecarrot', 'light.redruby', 'light.purplemonster'
  'dark.blueyale', 'dark.blueolympic', 'dark.bluenavy', 'dark.greenmoss', 'dark.greenlime', 'dark.yellowgranola', 'dark.greysteel', 'dark.orangecarrot', 'dark.redruby', 'dark.purplemonster'
  */
  defaultColor: 'light.blueolympic',
  isDarkSwitchActive: true,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'riesko-themeradius',
  isAuthGuardActive: true,
  firebase: {
    apiKey: 'AIzaSyCqoNLB_jTw4nncO12qR-eDH9gAeWiZVaw',
    authDomain: 'riesko-angular-login.firebaseapp.com',
    databaseURL: 'https://vien-angular-login.firebaseio.com',
    projectId: 'riesko-angular-login',
    storageBucket: 'riesko-angular-login.appspot.com',
    messagingSenderId: '16217062888',
    appId: '1:16217062888:web:6b08232ca0c9662fedb85d',
    measurementId: 'G-8ETT79WRRN'
  },
  // googleMapsApiKey: 'AIzaSyCIOYtKursOUQndCYcmBb3pdOMEh5jb8w4' //Daniele
  googleMapsApiKey: 'AIzaSyBv4KyCuvWlSRbTRqiEJ6vKfoakyt00k7w'
};
